<form>
  <div class="card w-100 mb-2 mb-sm-3 mb-md-4 mb-lg-5">
    <div class="p-3 border-b font-medium flex justify-between items-center">
      <span>Exercise leaderboard</span>
        <div class="flex items-center gap-3">
            <mat-button-toggle-group
                    name="fontStyle"
                    aria-label="Font Style"
                    [formControl]="timeFrame"
                    (change)="setTimeRange()"
            >
                <mat-button-toggle [value]="ETimeFilter.Today">
                <div class="flex flex-col">
                    <span>Today</span>
                    <div class="text-xs text-gray-500">{{todayTimeRange.end | date}} - {{todayTimeRange.end | date}}</div>
                </div>
                </mat-button-toggle>
                <mat-button-toggle [value]="ETimeFilter.LastWeek">
                    <div class="flex flex-col">
                        <span>Last week</span>
                        <div class="text-xs text-gray-500">{{lastWeekTimeRange.start | date}} - {{lastWeekTimeRange.end | date}}</div>
                    </div>
                </mat-button-toggle>
                <mat-button-toggle [value]="ETimeFilter.LastMonth">
                    <div class="flex flex-col">
                        <span>Last month</span>
                        <div class="text-xs text-gray-500">{{lastMonthTimeRange.start | date}} - {{lastMonthTimeRange.end | date}}</div>
                    </div>
                </mat-button-toggle>
                <mat-button-toggle [value]="ETimeFilter.AllTime">
                <div class="flex flex-col">
                    <span>All time</span>
                    <div class="text-xs text-gray-500">{{allTimeRange.start | date}} - {{allTimeRange.end | date}}</div>
                </div>
                </mat-button-toggle>
            </mat-button-toggle-group>
            <button mat-flat-button color="primary" (click)="openSelectExerciseConfigModal()">Select exercise</button>
        </div>

    </div>
    <div class="p-3 relative max-h-[800px] overflow-y-auto">
        <div *ngIf="!isLoading" class="flex flex-col gap-5">
            <div *ngIf="selectedExerciseTitle?.regularExercise" class="flex flex-col gap-2">
                <span class="text-2xl">{{selectedExerciseTitle.regularExercise.exerciseName}}</span>
                <span class="text-lg">({{selectedExerciseTitle.regularExercise.firstTitle}})</span>
            </div>
            <div *ngIf="selectedExerciseTitle?.pairedExercise" class="flex flex-col gap-2">
                <span class="text-2xl">{{selectedExerciseTitle.pairedExercise.exerciseName}}</span>
                <div class="flex flex-col gap-1 text-lg">
                    <span>({{selectedExerciseTitle.pairedExercise.firstTitle}})</span>
                    <span>({{selectedExerciseTitle.pairedExercise.secondTitle}})</span>
                </div>
            </div>
            <div class="relative overflow-x-auto [&_*]:!text-xl" *ngIf="leaderboardRows.length > 0">
                    <table class="w-full text-sm text-left rtl:text-right">
                        <thead class="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                <span (click)="toggleSort('rank')" class="cursor-pointer">
                                    Rank
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                            <th scope="col" class="px-6 py-3">
                                <span (click)="toggleSort('athleteName')" class="cursor-pointer">
                                    {{_pt('most_active_exercise_athelete_name')}}
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                            <th scope="col" class="px-6 py-3 text-center" >
                                <span (click)="toggleSort('average')" class="cursor-pointer">
                                    Average
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                            <th scope="col" class="px-6 py-3 text-center" >
                                <span (click)="toggleSort('averageComparison')" class="cursor-pointer">
                                    Average Comparison
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                            <th scope="col" class="px-6 py-3 text-center" >
                                <span (click)="toggleSort('best')" class="cursor-pointer">
                                    Best
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                            <th scope="col" class="px-6 py-3 text-center" >
                                <span (click)="toggleSort('bestComparison')" class="cursor-pointer">
                                    Best Comparison
                                    <mat-icon class="scale-[1.5]">swap_vert</mat-icon>
                                </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="border-b " *ngFor="let leaderboardRow of leaderboardRows" [class.bg-yellow-100]="leaderboardRow.rank === 1">
                            <th scope="row" class="px-6 py-4 font-medium whitespace-nowrap">
                                {{leaderboardRow.rank}}
                            </th>
                            <th scope="row" class="px-6 py-4 font-medium whitespace-nowrap">
                                {{leaderboardRow.athleteName}}
                            </th>
                            <th scope="row" class="px-6 py-4 font-medium whitespace-nowrap">
                                {{leaderboardRow.average}}
                            </th>
                            <td class="px-6 py-4">
                               <app-average-comparison [leaderboardRow]="leaderboardRow"></app-average-comparison>
                            </td>
                            <th scope="row" class="px-6 py-4 font-medium whitespace-nowrap">
                                {{leaderboardRow.best}}
                            </th>
                            <td class="px-6 py-4">
                                <app-best-comparison [leaderboardRow]="leaderboardRow"></app-best-comparison>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            <div *ngIf="leaderboardRows.length === 0" class="h-[400px] w-full flex items-center justify-center">
                <span class="text-center text-gray-400">The selected exercise has no leaderboard. Please select another exercise</span>
            </div>
        </div>
      <div
        *ngIf="isLoading"
        class="w-full h-[400px] flex justify-center items-center"
      >
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</form>
